import Vue from 'vue';
import axios from 'axios';

const uiDateFormat = 'DD/MM/YYYY';


export default {
  name: 'CmrContrPnlBillingGroups',
  components: {
    DataGridComp: require('@/customcontrols/datagrid.vue').default,
    BottomNavButtons: require('@/employee/captureMeterReadings/cmrControlPanel/cmrControlPanelBottomNavButtons.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      loader: false,
      dataSource: [],
      dataSourcePaginated: [],
      gridCols: [
        { dataField: 'name', name: 'name', caption: this.$t('captureMR.BillingGroups') },
      ],
      keyColumn: 'name',
      pageOptions: { pageSize: 10, total: 0, page: 1, from: null, to: null },
      selectedkeys: [],
      totalCount: 0,
      gridChoice: {},
      hasNextStep: false,
    }
  },
  watch: {},
  created() {
    if (this.$store.state.userProfile.portalCaptureMeterReadingsAdmin != true)
      this.$router.push('/employeeHome');

    this.getBillingGroups();
  },
  methods: {
    getBillingGroups() {
      this.loader = true;
      axios.post('/CaptureMeterReading/GetBillingGroups')
        .then(response => {
          this.dataSource = response.data.items;
          this.totalCount = response.data.items.length;
          this.pageChange({ pageSize: this.pageOptions.pageSize, pageNumber: this.pageOptions.page });
        })
        .catch(e => {
          this.$router.push('/login');
          return false;
        })
        .finally(() => { this.loader = false });
    },
    pageChange(pInfo) {
      let start = pInfo.pageNumber * pInfo.pageSize - pInfo.pageSize;
      let end = start + pInfo.pageSize;

      this.dataSourcePaginated = this.dataSource.slice(start, end);
    },
    calculateCellClass(value) {
      return value.data.problemStatusVal === 0 ? 'recordTypeOrange' :
        value.data.problemStatusVal === 1 ? 'recordTypeGray' :
          value.data.problemStatusVal === 2 ? 'recordTypeBlack' :
            value.data.problemStatusVal === 3 ? 'recordTypeTeal' :
              value.data.problemStatusVal === 4 ? 'recordTypeBlue' :
                value.data.problemStatusVal === 5 ? 'recordTypeGreen' : 'recordTypePurple';

    },
    selectionChanged(info) {

    },
    clearApplicationsIds() {
      this.selectedkeys = [];
      this.offlineAppIds = [];
    },
    onRowDblClick(info) { 
      this.gridChoice = this.dataSource.filter(b => b.name == info.data.name)[0];
      this.loader = true;
      this.dataObj.selected(this.gridChoice);
      this.loader = false;
      this.hasNextStep = true;
    },
  },
}
